// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 首页优化样式 */
.home-page { min-height:100vh; background:#ffffff; padding-bottom:40px; }

.home-header { padding:72px 0 46px; text-align:center; color:var(--color-text,#59d8e9); animation:fadeSlideUp .8s both; }
.home-header h1 { font-size:2.2rem; margin:0 0 14px; letter-spacing:1px; text-shadow:none; }
.home-header p { font-size:1rem; opacity:.9; margin:0; font-weight:500; }

.home-main { background:var(--color-bg); border-radius:28px 28px 0 0; min-height:70vh; padding:38px 0 10px; box-shadow:0 -6px 22px -8px rgba(0,0,0,.15); position:relative; animation:fadeSlideUp 1s .1s both; }

.services-preview { margin-bottom:34px; }
.services-preview h2 { text-align:center; color:var(--color-text); margin:0 0 22px; font-size:1.35rem; position:relative; }
.services-preview h2::after { content:""; width:48px; height:4px; border-radius:2px; background:linear-gradient(90deg,var(--color-primary),var(--color-primary-accent)); display:block; margin:10px auto 0; }

.service-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(150px,1fr)); gap:20px; margin-bottom:14px; }

.service-card {
  background: var(--color-surface);
  border-radius: 20px;
  text-align: left;
  box-shadow: var(--shadow-sm);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  isolation: isolate;
  transition: var(--transition-base);
  border: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  min-height: 160px; /* 确保足够的触摸区域 */
  min-width: 120px; /* 确保最小宽度 */
}


.service-card::before { content:""; position:absolute; inset:0; background:linear-gradient(145deg,rgba(99,102,241,.08),rgba(79,70,229,.12)); opacity:0; transition:var(--transition-base); z-index:-1; }
.service-card:hover { transform:translateY(-6px); box-shadow:var(--shadow-lg); }
.service-card:hover::before { opacity:1; }
.service-card:focus-visible { outline:none; box-shadow:var(--focus-ring); }

.service-thumb {
  width: 100%;
  aspect-ratio: 16/10;
  object-fit: cover;
  border-radius: 14px 14px 0 0;
  margin: 0;
  filter: brightness(.97);
  transition: var(--transition-fast);
  background: var(--color-surface-alt); /* 加载时的背景色 */
  display: block; /* 确保图片正确显示 */
}

.service-card:hover .service-thumb {
  filter: brightness(1.03) saturate(1.08);
}

/* 移动端图片优化 */
@media (max-width: 768px) {
  .service-thumb {
    border-radius: 12px 12px 0 0;
  }

  /* 减少hover效果以提升性能 */
  .service-card:hover .service-thumb {
    filter: brightness(1.01) saturate(1.02);
    transform: none;
  }
}

@media (max-width: 480px) {
  .service-thumb {
    border-radius: 10px 10px 0 0;
  }
}

@media (max-width: 360px) {
  .service-thumb {
    border-radius: 8px 8px 0 0;
  }
}

.service-card-content { padding:12px 14px 14px; flex-grow:1; display:flex; flex-direction:column; }
.service-card h3 { margin:0 0 6px; font-size:.9rem; font-weight:600; color:var(--color-text); line-height:1.4; }
.service-card p { margin:0 0 10px; font-size:.75rem; letter-spacing:.3px; color:var(--color-text-sec); flex-grow:1; line-height:1.5; }

.service-card-footer { display:flex; justify-content:space-between; align-items:center; margin-top:auto; padding-top:8px; border-top:1px solid var(--color-border-light); }
.service-card-footer .price { font-size:.95rem; font-weight:700; color:var(--color-danger); }
.service-card-footer .duration { font-size:.7rem; color:var(--color-muted); background-color:var(--color-surface-alt); padding:3px 8px; border-radius:12px; }

/* 预约按钮区域已移除，保留占位可在需要时恢复 */
.action-buttons { display:none; }

/* 页脚备案信息 */
.site-footer { text-align:center; padding:28px 12px 34px; font-size:12px; color:#888; }
.site-footer .icp-link { color:#888; text-decoration:none; transition:color .2s; }
.site-footer .icp-link:hover { color:#555; text-decoration:underline; }

@media (min-width:600px) {
  .service-grid { grid-template-columns:repeat(auto-fill,minmax(180px,1fr)); }
  .service-card h3 { font-size:1rem; }
  .service-card p { font-size:.8rem; }
}

/* 移动端响应式优化 */
@media (max-width: 480px) {
  .home-header { padding: 64px 0 40px; }
  .home-header h1 { font-size: 1.9rem; }

  .service-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 14px;
  }

  .service-card {
    min-height: 160px; /* 确保足够的触摸区域 */
    min-width: 140px;
  }

  .service-card-content {
    padding: 14px 12px 16px;
  }

  .service-card h3 {
    font-size: .9rem;
    margin-bottom: 8px;
  }

  .service-card p {
    font-size: .7rem;
    line-height: 1.4;
  }

  .service-card-footer .price {
    font-size: .85rem;
  }

  .service-card-footer .duration {
    font-size: .65rem;
    padding: 4px 8px;
  }

  /* 如果有操作按钮 */
  .action-buttons {
    flex-direction: column;
    gap: 12px;
  }

  .action-buttons .btn {
    width: 100%;
    min-height: 48px;
    padding: 14px 20px;
  }
}

@media (max-width: 360px) {
  .service-grid { gap: 12px; }

  .service-card {
    min-height: 150px; /* 保持足够的触摸区域 */
    min-width: 120px;
  }

  .service-card-content {
    padding: 12px 10px 14px;
  }

  .service-card h3 {
    font-size: .85rem;
  }

  .service-card p {
    font-size: .65rem;
  }

  .service-card-footer .price {
    font-size: .8rem;
  }

  .service-card-footer .duration {
    font-size: .6rem;
    padding: 3px 6px;
  }
}

/* 触摸设备优化 */
@media (pointer: coarse) {
  .service-card {
    min-height: 180px;
    min-width: 160px;
  }

  .service-card-content {
    padding: 16px 14px 18px;
  }

  .action-buttons .btn {
    min-height: 52px;
    padding: 16px 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/HomePage.css"],"names":[],"mappings":"AAAA,WAAW;AACX,aAAa,gBAAgB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;;AAExE,eAAe,mBAAmB,EAAE,iBAAiB,EAAE,+BAA+B,EAAE,8BAA8B,EAAE;AACxH,kBAAkB,gBAAgB,EAAE,eAAe,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;AAC3F,iBAAiB,cAAc,EAAE,UAAU,EAAE,QAAQ,EAAE,eAAe,EAAE;;AAExE,aAAa,0BAA0B,EAAE,2BAA2B,EAAE,eAAe,EAAE,mBAAmB,EAAE,2CAA2C,EAAE,iBAAiB,EAAE,iCAAiC,EAAE;;AAE/M,oBAAoB,kBAAkB,EAAE;AACxC,uBAAuB,iBAAiB,EAAE,uBAAuB,EAAE,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE;AAC1H,8BAA8B,UAAU,EAAE,UAAU,EAAE,UAAU,EAAE,iBAAiB,EAAE,kFAAkF,EAAE,aAAa,EAAE,kBAAkB,EAAE;;AAE5M,gBAAgB,YAAY,EAAE,yDAAyD,EAAE,QAAQ,EAAE,kBAAkB,EAAE;;AAEvH;EACE,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,cAAc;EACjC,gBAAgB,EAAE,WAAW;AAC/B;;;AAGA,wBAAwB,UAAU,EAAE,iBAAiB,EAAE,OAAO,EAAE,2EAA2E,EAAE,SAAS,EAAE,iCAAiC,EAAE,UAAU,EAAE;AACvM,sBAAsB,0BAA0B,EAAE,2BAA2B,EAAE;AAC/E,8BAA8B,SAAS,EAAE;AACzC,8BAA8B,YAAY,EAAE,4BAA4B,EAAE;;AAE1E;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC,EAAE,YAAY;EAClD,cAAc,EAAE,aAAa;AAC/B;;AAEA;EACE,uCAAuC;AACzC;;AAEA,YAAY;AACZ;EACE;IACE,4BAA4B;EAC9B;;EAEA,mBAAmB;EACnB;IACE,uCAAuC;IACvC,eAAe;EACjB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,wBAAwB,sBAAsB,EAAE,WAAW,EAAE,YAAY,EAAE,qBAAqB,EAAE;AAClG,mBAAmB,cAAc,EAAE,eAAe,EAAE,eAAe,EAAE,uBAAuB,EAAE,eAAe,EAAE;AAC/G,kBAAkB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,2BAA2B,EAAE,WAAW,EAAE,eAAe,EAAE;;AAErI,uBAAuB,YAAY,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,eAAe,EAAE,eAAe,EAAE,8CAA8C,EAAE;AAC1K,8BAA8B,gBAAgB,EAAE,eAAe,EAAE,yBAAyB,EAAE;AAC5F,iCAAiC,eAAe,EAAE,wBAAwB,EAAE,yCAAyC,EAAE,eAAe,EAAE,kBAAkB,EAAE;;AAE5J,0BAA0B;AAC1B,kBAAkB,YAAY,EAAE;;AAEhC,WAAW;AACX,eAAe,iBAAiB,EAAE,sBAAsB,EAAE,cAAc,EAAE,UAAU,EAAE;AACtF,yBAAyB,UAAU,EAAE,oBAAoB,EAAE,oBAAoB,EAAE;AACjF,+BAA+B,UAAU,EAAE,yBAAyB,EAAE;;AAEtE;EACE,gBAAgB,yDAAyD,EAAE;EAC3E,mBAAmB,cAAc,EAAE;EACnC,kBAAkB,eAAe,EAAE;AACrC;;AAEA,aAAa;AACb;EACE,eAAe,oBAAoB,EAAE;EACrC,kBAAkB,iBAAiB,EAAE;;EAErC;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,iBAAiB,EAAE,cAAc;IACjC,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA,YAAY;EACZ;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB,SAAS,EAAE;;EAE3B;IACE,iBAAiB,EAAE,cAAc;IACjC,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":["/* 首页优化样式 */\r\n.home-page { min-height:100vh; background:#ffffff; padding-bottom:40px; }\r\n\r\n.home-header { padding:72px 0 46px; text-align:center; color:var(--color-text,#59d8e9); animation:fadeSlideUp .8s both; }\r\n.home-header h1 { font-size:2.2rem; margin:0 0 14px; letter-spacing:1px; text-shadow:none; }\r\n.home-header p { font-size:1rem; opacity:.9; margin:0; font-weight:500; }\r\n\r\n.home-main { background:var(--color-bg); border-radius:28px 28px 0 0; min-height:70vh; padding:38px 0 10px; box-shadow:0 -6px 22px -8px rgba(0,0,0,.15); position:relative; animation:fadeSlideUp 1s .1s both; }\r\n\r\n.services-preview { margin-bottom:34px; }\r\n.services-preview h2 { text-align:center; color:var(--color-text); margin:0 0 22px; font-size:1.35rem; position:relative; }\r\n.services-preview h2::after { content:\"\"; width:48px; height:4px; border-radius:2px; background:linear-gradient(90deg,var(--color-primary),var(--color-primary-accent)); display:block; margin:10px auto 0; }\r\n\r\n.service-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(150px,1fr)); gap:20px; margin-bottom:14px; }\r\n\r\n.service-card {\r\n  background: var(--color-surface);\r\n  border-radius: 20px;\r\n  text-align: left;\r\n  box-shadow: var(--shadow-sm);\r\n  cursor: pointer;\r\n  position: relative;\r\n  overflow: hidden;\r\n  isolation: isolate;\r\n  transition: var(--transition-base);\r\n  border: 1px solid var(--color-border);\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-height: 160px; /* 确保足够的触摸区域 */\r\n  min-width: 120px; /* 确保最小宽度 */\r\n}\r\n\r\n\r\n.service-card::before { content:\"\"; position:absolute; inset:0; background:linear-gradient(145deg,rgba(99,102,241,.08),rgba(79,70,229,.12)); opacity:0; transition:var(--transition-base); z-index:-1; }\r\n.service-card:hover { transform:translateY(-6px); box-shadow:var(--shadow-lg); }\r\n.service-card:hover::before { opacity:1; }\r\n.service-card:focus-visible { outline:none; box-shadow:var(--focus-ring); }\r\n\r\n.service-thumb {\r\n  width: 100%;\r\n  aspect-ratio: 16/10;\r\n  object-fit: cover;\r\n  border-radius: 14px 14px 0 0;\r\n  margin: 0;\r\n  filter: brightness(.97);\r\n  transition: var(--transition-fast);\r\n  background: var(--color-surface-alt); /* 加载时的背景色 */\r\n  display: block; /* 确保图片正确显示 */\r\n}\r\n\r\n.service-card:hover .service-thumb {\r\n  filter: brightness(1.03) saturate(1.08);\r\n}\r\n\r\n/* 移动端图片优化 */\r\n@media (max-width: 768px) {\r\n  .service-thumb {\r\n    border-radius: 12px 12px 0 0;\r\n  }\r\n\r\n  /* 减少hover效果以提升性能 */\r\n  .service-card:hover .service-thumb {\r\n    filter: brightness(1.01) saturate(1.02);\r\n    transform: none;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .service-thumb {\r\n    border-radius: 10px 10px 0 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .service-thumb {\r\n    border-radius: 8px 8px 0 0;\r\n  }\r\n}\r\n\r\n.service-card-content { padding:12px 14px 14px; flex-grow:1; display:flex; flex-direction:column; }\r\n.service-card h3 { margin:0 0 6px; font-size:.9rem; font-weight:600; color:var(--color-text); line-height:1.4; }\r\n.service-card p { margin:0 0 10px; font-size:.75rem; letter-spacing:.3px; color:var(--color-text-sec); flex-grow:1; line-height:1.5; }\r\n\r\n.service-card-footer { display:flex; justify-content:space-between; align-items:center; margin-top:auto; padding-top:8px; border-top:1px solid var(--color-border-light); }\r\n.service-card-footer .price { font-size:.95rem; font-weight:700; color:var(--color-danger); }\r\n.service-card-footer .duration { font-size:.7rem; color:var(--color-muted); background-color:var(--color-surface-alt); padding:3px 8px; border-radius:12px; }\r\n\r\n/* 预约按钮区域已移除，保留占位可在需要时恢复 */\r\n.action-buttons { display:none; }\r\n\r\n/* 页脚备案信息 */\r\n.site-footer { text-align:center; padding:28px 12px 34px; font-size:12px; color:#888; }\r\n.site-footer .icp-link { color:#888; text-decoration:none; transition:color .2s; }\r\n.site-footer .icp-link:hover { color:#555; text-decoration:underline; }\r\n\r\n@media (min-width:600px) {\r\n  .service-grid { grid-template-columns:repeat(auto-fill,minmax(180px,1fr)); }\r\n  .service-card h3 { font-size:1rem; }\r\n  .service-card p { font-size:.8rem; }\r\n}\r\n\r\n/* 移动端响应式优化 */\r\n@media (max-width: 480px) {\r\n  .home-header { padding: 64px 0 40px; }\r\n  .home-header h1 { font-size: 1.9rem; }\r\n\r\n  .service-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 14px;\r\n  }\r\n\r\n  .service-card {\r\n    min-height: 160px; /* 确保足够的触摸区域 */\r\n    min-width: 140px;\r\n  }\r\n\r\n  .service-card-content {\r\n    padding: 14px 12px 16px;\r\n  }\r\n\r\n  .service-card h3 {\r\n    font-size: .9rem;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .service-card p {\r\n    font-size: .7rem;\r\n    line-height: 1.4;\r\n  }\r\n\r\n  .service-card-footer .price {\r\n    font-size: .85rem;\r\n  }\r\n\r\n  .service-card-footer .duration {\r\n    font-size: .65rem;\r\n    padding: 4px 8px;\r\n  }\r\n\r\n  /* 如果有操作按钮 */\r\n  .action-buttons {\r\n    flex-direction: column;\r\n    gap: 12px;\r\n  }\r\n\r\n  .action-buttons .btn {\r\n    width: 100%;\r\n    min-height: 48px;\r\n    padding: 14px 20px;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .service-grid { gap: 12px; }\r\n\r\n  .service-card {\r\n    min-height: 150px; /* 保持足够的触摸区域 */\r\n    min-width: 120px;\r\n  }\r\n\r\n  .service-card-content {\r\n    padding: 12px 10px 14px;\r\n  }\r\n\r\n  .service-card h3 {\r\n    font-size: .85rem;\r\n  }\r\n\r\n  .service-card p {\r\n    font-size: .65rem;\r\n  }\r\n\r\n  .service-card-footer .price {\r\n    font-size: .8rem;\r\n  }\r\n\r\n  .service-card-footer .duration {\r\n    font-size: .6rem;\r\n    padding: 3px 6px;\r\n  }\r\n}\r\n\r\n/* 触摸设备优化 */\r\n@media (pointer: coarse) {\r\n  .service-card {\r\n    min-height: 180px;\r\n    min-width: 160px;\r\n  }\r\n\r\n  .service-card-content {\r\n    padding: 16px 14px 18px;\r\n  }\r\n\r\n  .action-buttons .btn {\r\n    min-height: 52px;\r\n    padding: 16px 24px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
